export default __webpack_public_path__ + "static/media/burglary_theft.a690d66a.svg";